<template>
  <div id="kt_scrolltop" class="kt-scrolltop">
    <i class="fa fa-arrow-up" />
  </div>
</template>

<script>
import KTScrolltop from "@/assets/js/scrolltop.js";
export default {
  name: "Scrolltop",
  mounted() {
    new KTScrolltop("kt_scrolltop", {
      offset: 300,
      speed: 600
    });
  }
};
</script>
